import Guidance from "components/views/atoms/Guidance"
import { IPageGuidance } from "contentful-types"
import React from "react"

type GuidanceElementProps = {
  guidance: IPageGuidance
}

const GuidanceElement = ({ guidance }: GuidanceElementProps) => {
  const {
    fields: { title, description }
  } = guidance
  return <>{title && description ? <Guidance title={title} description={description} /> : null}</>
}

export { GuidanceElement }
